import http from "@/utils/request";

const shopAuth = {
  pinduoduoAuthByCode: data =>
    http.sendRequest({
      METHOD_NAME: "pinduoduo.authByCode",
      SECURITY_TYPE: "Integrated",
      data,
      ERROR_CODE: {}
    }),
  list: data =>
    http.sendRequest({
      METHOD_NAME: "shopAuthorize.list",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  async listAll() {
    const items = [];
    let currentPage = 1;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const res = await shopAuth.list({
        request: { pageInfo: { currentPage, pageSize: 500 } }
      });
      const page = res && res.pageInfo;
      if (!page || !Array.isArray(res.items) ||
          page.currentPage !== currentPage ||
          !Number.isInteger(page.totalCount) || page.totalCount < 0) {
        throw new Error("店铺分页数据异常");
      }
      items.push(...res.items);
      if (items.length >= page.totalCount) {
        return { items };
      }
      if (res.items.length === 0) {
        throw new Error("店铺列表未加载完整");
      }
      currentPage += 1;
    }
  },
  updateStatus: data =>
    http.sendRequest({
      METHOD_NAME: "shopAuthorize.updateStatus",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  shopAuthorizeDelete: data =>
    http.sendRequest({
      METHOD_NAME: "shopAuthorize.delete",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  bindDeclareParams: data =>
    http.sendRequest({
      METHOD_NAME: "shop.bindDeclareParams",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  create: data =>
    http.sendRequest({
      METHOD_NAME: "shop.create",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    })
};

export default shopAuth;
